export interface HotelFilterType {
  selectedHotels: server.dto.CompanySmall[]
}

export const getSortedHotelLabels = (filter: HotelFilterType) => {
  return filter.selectedHotels.map(a => a.name)
    .sort((a, b) => a.localeCompare(b));
};

export const initialHotelFilter: HotelFilterType = {
  selectedHotels: []
};